export enum Permission {
  View = 'feature_entitlements.view',
}
